<template>
  <div class="breadcrumbs">
    <ul>
      <li>
        <router-link to="/editor/projects">Projects</router-link>
      </li>
      <li v-if="selectedProject">
        <router-link
          :class="{isActive: selectedProject}"
          :to="`/editor/project/${this.$route.params.id}`"
        >{{selectedProject.name}}</router-link>
      </li>
      <li v-if="selectedScene">
        <router-link :class="{isActive: selectedScene}" to="#">{{selectedScene.name}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["selectedProject", "selectedScene"])
  }
};
</script>

<style lang="scss">
.breadcrumbs {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding-left: 40px;
  height: 96px;
  font-size: 18px;

  ul {
    display: flex;
    margin: 0;
    padding: 0;
  }

  li {
    &::after {
      content: ">";
      color: #b5b5be;
      padding: 0 5px;
    }

    &:last-of-type {
      &::after {
        content: "";
      }
    }
  }

  ul,
  li {
    list-style: none;
  }

  a {
    color: #b5b5be;
    text-decoration: none;

    &:hover {
      color: #333;
    }

    &.isActive {
      color: #333;
    }
  }
}
</style>
